import { Autocomplete, AutocompleteChangeDetails, AutocompleteChangeReason, Grid, TextField } from '@mui/material';
import _ from 'lodash';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CargoGroupModel from './models/CargoGroupModel';
import CargoTypeModel from './models/CargoTypeModel';
import { cargoTypeSelectorSelector } from './reducers/CargoTypeSelectorReducer';
import './CargoTypeSelector.scss';
import { AutoCompleteFilterOptionState } from '../Tonnage/components/TonnageNameSelector';

interface CargoSelectorProp {
    cargoTypeValues?: CargoTypeModel[],
    cargoGroupValues?: CargoGroupModel[],
    className?: string,
    hideCargoGroup?: boolean,
    hideOpposite?: boolean,
    onCargoTypeChange?: (cargoType: CargoTypeModel[]) => void,
    onCargoGroupChange?: (cargoType: CargoGroupModel[]) => void
}

const CargoTypeMultipleSelector: React.FunctionComponent<CargoSelectorProp> = (props) => {
    const defaultCargoTypeValue: CargoTypeModel[] | undefined = props.cargoTypeValues ? props.cargoTypeValues : [];
    const defaultCargoGroupValue: CargoGroupModel[] | undefined = props.cargoGroupValues ? props.cargoGroupValues : [];

    let dispatch = useDispatch();
    let cargoTypeSelectorData = useSelector(cargoTypeSelectorSelector);
    let [cargoTypeValues, setCargoTypeValues] = useState<CargoTypeModel[]>(defaultCargoTypeValue);
    let [cargoGroupValues, setCargoGroupValues] = useState<CargoGroupModel[]>(defaultCargoGroupValue);
    const [open, setOpen] = useState(false);
    const filterLimit = 10;

    useEffect(() => {
        let cargoTypeValues = props.cargoTypeValues ? props.cargoTypeValues : [];
        setCargoTypeValues(cargoTypeValues);
    }, [props.cargoTypeValues])

    useEffect(() => {
        let cargoGroupValues = props.cargoGroupValues ? props.cargoGroupValues : [];
        setCargoGroupValues(cargoGroupValues);
    }, [props.cargoGroupValues])

    return <>
        {
            cargoTypeSelectorData.cargoTypes &&
            <Grid container>
                <Grid item xs={12}>
                    <Autocomplete
                        className={props.className ? props.className : ""}
                        multiple
                        value={cargoTypeValues}
                        options={cargoTypeSelectorData.cargoTypes}
                        renderInput={(params) => <TextField {...params} label="Cargo" />}
                        getOptionLabel={(option: CargoTypeModel) => {
                            return option.name;
                        }}
                        onChange={(event: SyntheticEvent<Element, Event>, value: CargoTypeModel[], reason: AutocompleteChangeReason, details?: AutocompleteChangeDetails<CargoTypeModel> | undefined) => {
                            if (props.onCargoTypeChange) {
                                props.onCargoTypeChange(value);
                            }

                            setCargoTypeValues(value);
                        }}
                        renderTags={(value: readonly CargoTypeModel[], getTagProps) => {
                            return value.map((option: CargoTypeModel, index: number) => {
                                let isPositive = option.positive === undefined || option.positive === true;
                                let className = isPositive ? "tag-filter-positive" : "tag-filter-negative";

                                return <span className={"tag-filter " + className} >
                                    {
                                        !props.hideOpposite &&
                                        <i className="fa fa-refresh" aria-hidden="true"
                                        onClick={() => {
                                            let items = [...cargoTypeValues];
                                            items[index] = {
                                                ...items[index],
                                                positive: !isPositive
                                            }
                                            setCargoTypeValues(items);

                                            if (props.onCargoTypeChange) {
                                                props.onCargoTypeChange(items);
                                            }
                                        }} ></i>
                                    }
                                    &nbsp;
                                    {option.name}
                                    &nbsp;
                                    <i className="fa fa-times" aria-hidden="true"
                                        onClick={() => {
                                            let items = [...cargoTypeValues];
                                            items.splice(index, 1);
                                            setCargoTypeValues(items);

                                            if (props.onCargoTypeChange) {
                                                props.onCargoTypeChange(items);
                                            }
                                        }}
                                    ></i>
                                </span>
                            })
                        }}
                        filterOptions={(options: Array<CargoTypeModel>, state: AutoCompleteFilterOptionState) => {
                            let inputValue = state.inputValue;

                            let searchResults = options.filter((option) => option.name.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
                            let searchResultsExcludeSelectedValue = _.filter(searchResults, (option) => {
                                return _.findIndex(props.cargoTypeValues, (value) => {
                                    return option.name.toLowerCase() === value.name.toLowerCase();
                                }) < 0;
                            });

                            return _.take(searchResultsExcludeSelectedValue, filterLimit);
                        }}
                    />
                </Grid>
                {
                    props.hideCargoGroup == true &&
                    <Grid item xs={12}>
                        <Autocomplete
                            className={props.className ? props.className : ""}
                            multiple
                            value={cargoGroupValues}
                            options={cargoTypeSelectorData.cargoGroups}
                            renderInput={(params) => <TextField {...params} label="Group" />}
                            getOptionLabel={(option: CargoGroupModel) => {
                                return option.cargoGroupName;
                            }}
                            onChange={(event: SyntheticEvent<Element, Event>, value: CargoGroupModel[], reason: AutocompleteChangeReason, details?: AutocompleteChangeDetails<CargoGroupModel> | undefined) => {
                                if (props.onCargoGroupChange) {
                                    props.onCargoGroupChange(value);
                                }

                                setCargoGroupValues(value);
                            }}
                            renderTags={(value: readonly CargoGroupModel[], getTagProps) => {
                                return value.map((option: CargoGroupModel, index: number) => {
                                    let isPositive = option.positive === undefined || option.positive === true;
                                    let className = isPositive ? "tag-filter-positive" : "tag-filter-negative";

                                    return <span className={"tag-filter " + className} >
                                        <i className="fa fa-refresh" aria-hidden="true"
                                            onClick={() => {
                                                let items = [...cargoGroupValues];
                                                items[index] = {
                                                    ...items[index],
                                                    positive: !isPositive
                                                }
                                                setCargoGroupValues(items);

                                                if (props.onCargoGroupChange) {
                                                    props.onCargoGroupChange(items);
                                                }
                                            }} ></i> &nbsp;
                                        {option.cargoGroupName}
                                        &nbsp;
                                        <i className="fa fa-times" aria-hidden="true"
                                            onClick={() => {
                                                let items = [...cargoGroupValues];
                                                items.splice(index, 1);
                                                setCargoGroupValues(items);

                                                if (props.onCargoGroupChange) {
                                                    props.onCargoGroupChange(items);
                                                }
                                            }}
                                        ></i>
                                    </span>
                                })
                            }}
                            filterOptions={(options: Array<CargoGroupModel>, state: AutoCompleteFilterOptionState) => {
                                let inputValue = state.inputValue;

                                let searchResults = options.filter((option) => option.cargoGroupName.indexOf(inputValue) > -1);
                                let searchResultsExcludeSelectedValue = _.filter(searchResults, (option) => {
                                    return _.findIndex(props.cargoGroupValues, (value) => {
                                        return option.cargoGroupName === value.cargoGroupName;
                                    }) < 0;
                                });

                                return _.take(searchResultsExcludeSelectedValue, filterLimit);
                            }}
                        />
                    </Grid>
                }
            </Grid>
        }
    </>;
};

export default CargoTypeMultipleSelector;